export const ndsStatusConfig = {
  not_stated: { text: 'не указан', color: 'grey' },
  used: { text: 'с НДС 20%', color: 'green' },
  used_22: { text: 'с НДС 22%', color: 'green' },
  used_5: { text: 'с НДС 5%', color: 'green' },
  used_7: { text: 'с НДС 7%', color: 'green' },
  not_used: { text: 'без НДС', color: 'gold' },
}

export const registryOptions = {
  registry_ast: {
    text: 'registry_ast',
    name: 'Мирогрупп 3 больше не нужен',
    file: require('@/assets/img/registries/client_registry_ast.png'),
    fileName: 'client_registry_ast',
  },
  registry_default: {
    text: 'registry_default',
    name: 'Мирогрупп',
    file: require('@/assets/img/registries/client_registry_default.png'),
    fileName: 'client_registry_default',
  },
  registry_agroconsult: {
    text: 'registry_agroconsult',
    name: 'Агроконсалтинг',
    file: require('@/assets/img/registries/agro-consulting.png'),
    fileName: 'client_registry_agroconsult',
  },
  registry_mirogroup: {
    text: 'registry_mirogroup',
    name: 'Мирогрупп новый',
    file: require('@/assets/img/registries/client_registry_mirogrup.png'),
    fileName: 'client_registry_mirogrup',
  },
  registry_mzk: {
    text: 'registry_mzk',
    name: 'Гленкор',
    file: require('@/assets/img/registries/client_registry_mzk.png'),
    fileName: 'client_registry_mzk',
  },
  registry_ozk_ug: {
    text: 'registry_ozk_ug',
    name: 'ОЗК',
    file: require('@/assets/img/registries/client_registry_ozk_ug.png'),
    fileName: 'client_registry_ozk_ug',
  },
  registry_step: {
    text: 'registry_step',
    name: 'ТД Степь больше не нужен',
    file: require('@/assets/img/registries/client_registry_step.png'),
    fileName: 'client_registry_step',
  },
  registry_apk_ast: {
    text: 'registry_apk_ast',
    name: 'Старощербиновская АСТ',
    file: require('@/assets/img/registries/ст_Старощербиновская_НЗТ.png'),
    fileName: 'ст_Старощербиновская_НЗТ',
  },
  registry_volga_grain: {
    text: 'registry_volga_grain',
    name: 'Зерно Заволжья',
    file: require('@/assets/img/registries/Зерно_Заволжья.png'),
    fileName: 'Зерно_Заволжья',
  },
  registry_npk_agro: {
    text: 'registry_npk_agro',
    name: 'Агро Групп',
    file: require('@/assets/img/registries/agro_group.png'),
    fileName: 'Агро_Групп',
  },
}
